import { defineStore } from 'pinia'
import { ref } from 'vue'
import { episodeService } from '@/services/episodeService'
import { logger } from '@/services/loggerService'

export const useClientEpisodesStore = defineStore('clientEpisodes', () => {
  // ─── State ───────────────────────────────────────
  const episodes = ref([])
  const isLoading = ref(false)
  let unsubscribe = null

  // ─── Actions ─────────────────────────────────────

  /**
   * Subscribe to episodes for a show (real-time)
   */
  function subscribeToShowEpisodes(showId, companyId = null) {
    dispose()
    isLoading.value = true

    unsubscribe = episodeService.subscribeToShowEpisodes(showId, (episodeList) => {
      episodes.value = episodeList
      isLoading.value = false
      logger.info('[ClientEpisodesStore] Episodes updated', { showId, count: episodeList.length })
    }, companyId)
  }

  function dispose() {
    if (unsubscribe) {
      unsubscribe()
      unsubscribe = null
    }
  }

  function reset() {
    dispose()
    episodes.value = []
    isLoading.value = false
  }

  return {
    episodes,
    isLoading,
    subscribeToShowEpisodes,
    dispose,
    reset
  }
})
